module.exports = __webpack_public_path__ + "img/step2.cead9c05.png";